import React, { useState } from "react";
import { useParams } from "react-router-dom";
import behandelingenData from "../../data/behandelingen.json";
// import BeforeAfterSlider from "../../components/BeforeAfterSlider";

const BehandelingDetail = () => {
  const { behandelingId } = useParams();
  const behandeling = behandelingenData.find((b) => b.id === behandelingId);

  const [open, setOpen] = useState(false);

  React.useEffect(() => {
    if (behandeling) {
      setOpen(behandeling.isOpen !== undefined ? behandeling.isOpen : true);
    }
  }, [behandeling]);

  if (!behandeling) {
    return <p>Behandeling niet gevonden.</p>;
  }

  const {
    title,
    paragraph,
    title_h2,
    paragraph_h2,
    title_h3,
    paragraph_h3,
    title_h3_1,
    paragraph_h3_1,
    image,
    price_title_1,
    price_1,
    price_title_2,
    price_2,
    price_title_3,
    price_3,
    price_title_4,
    price_4,
    behandeltijd,
    controle,
    effect
  } = behandeling;

  const toggleOpen = () => {
    setOpen(!open);
  };

  return (
    <>
      {/* <div className="sticky-subpage">
        <div className="sticky">
          <div className="sticky-container">
            <div className="sticky-content">
              <div className="sticky-title"></div>
              <ul>
                <li>Pijnloze behandeling</li>
                <li>Lichaamseigen stof</li>
                <li>15 jaar ervaring</li>
              </ul>
              <p>
                <img
                  src="https://www.queencenter.nl/wp-content/uploads/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/wp-content/uploads/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/wp-content/uploads/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/wp-content/uploads/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/wp-content/uploads/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <br /> Wij scoren{" "}
                <a
                  href="https://www.google.com/search?q=queen+center&amp;client=firefox-b-d&amp;source=lnms&amp;sa=X&amp;ved=0ahUKEwjKqoz1-dniAhVKzqYKHVo1ALwQ_AUICygA&amp;biw=1440&amp;bih=733&amp;dpr=2#lrd=0x47c709aeeb9ce9e5:0xdc7d04e5f37e8a4a,1,,,"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  9,8 van 10
                </a>
                <br /> berekend uit 43 reviews.
              </p>
            </div>
          </div>
        </div>
      </div> */}
      <div className="subpage-container">
        <div className="subpage-content">
          <h1>{title}</h1>
          {/* <BeforeAfterSlider /> */}
          <img src={image} alt={title} />
          <div className="behandeling-info-container">
            <div className="behandeling-info">
              <div className="behandel-info">
                <img src="/images/icon-time.svg" alt="Time icon" />
                <p>Behandeltijd</p>
              </div>
              <p className="title">{behandeltijd}</p>
            </div>
            <div className="controle-info">
              <div className="behandel-info">
                <img src="/images/icon-controle.svg" alt="Controle icon" />
                <p>Controle na</p>
              </div>
              <p className="title">{controle}</p>
            </div>
            <div className="effect-info">
              <div className="behandel-info">
                <img src="/images/icon-effect.svg" alt="Controle icon" />
                <p>Effect (bij herhaling)</p>
              </div>
              <p className="title">{effect}</p>
            </div>
          </div>
          <p>{paragraph}</p>
          <h2>{title_h2}</h2>
          <p>{paragraph_h2}</p>
          <h3>{title_h3}</h3>
          <p>{paragraph_h3}</p>
          <h3>{title_h3_1}</h3>
          <p>{paragraph_h3_1}</p>

          <div className={`behandeling ${open ? "open" : ""}`}>
            <div className="behandeling-title">
              <h4>Prijslijst</h4>
              <button className="toggle-button" onClick={toggleOpen}>
                {open ? "" : ""}
                <img
                  src="/images/arrow-down.svg"
                  className="price-icon"
                  alt="Toggle Prices"
                />
              </button>
            </div>
            {open && (
              <div className="behandeling-dropdown">
                {price_title_1 && price_1 && (
                  <div className="behandeling-price">
                    <p>{price_title_1}</p>
                    <p>
                      <span>{price_1}</span>
                    </p>
                  </div>
                )}
                {price_title_2 && price_2 && (
                  <div className="behandeling-price">
                    <p>{price_title_2}</p>
                    <p>
                      <span>{price_2}</span>
                    </p>
                  </div>
                )}
                {price_title_3 && price_3 && (
                  <div className="behandeling-price">
                    <p>{price_title_3}</p>
                    <p>
                      <span>{price_3}</span>
                    </p>
                  </div>
                )}
                {price_title_4 && price_4 && (
                  <div className="behandeling-price">
                    <p>{price_title_4}</p>
                    <p>
                      <span>{price_4}</span>
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BehandelingDetail;
